import React, { useState, useEffect } from 'react';
import { Save, Clock } from 'lucide-react';
import toast from 'react-hot-toast';
import OwnerLayout from '../../components/OwnerLayout';
import api from '../../utils/api';

export default function OwnerProfile() {
  const [form, setForm] = useState({ name: '', whatsapp: '', address: '', logo: '', opening_time: '09:00', closing_time: '22:00' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/api/owner/restaurant')
      .then(res => setForm({ ...form, ...res.data }))
      .catch(() => toast.error('Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    if (!form.name || !form.whatsapp) return toast.error('Name and WhatsApp are required');
    setSaving(true);
    try {
      await api.patch('/api/owner/restaurant', form);
      toast.success('Profile updated!');
    } catch { toast.error('Failed to save'); }
    finally { setSaving(false); }
  };

  return (
    <OwnerLayout title="Restaurant Profile">
      {loading ? (
        <div style={{ textAlign: 'center', padding: 48 }}><div className="spinner" style={{ margin: '0 auto' }} /></div>
      ) : (
        <form onSubmit={handleSave} className="fade-in">
          {/* Logo Preview */}
          <div className="card" style={styles.logoCard}>
            <div style={styles.logoPreview}>
              {form.logo ? (
                <img src={form.logo} alt="Logo" style={styles.logoImg} />
              ) : (
                <span style={{ fontSize: 48 }}>🍽️</span>
              )}
            </div>
            <p style={styles.logoHint}>Restaurant Logo</p>
          </div>

          <div className="card" style={{ marginBottom: 12 }}>
            <h3 style={styles.sectionTitle}>Basic Info</h3>
            <div className="form-group">
              <label className="label">Restaurant Name *</label>
              <input className="input" placeholder="Your restaurant name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="label">WhatsApp Number * <span style={{ color: '#7F8C8D', fontWeight: 400, fontSize: 11 }}>(orders will come here)</span></label>
              <input className="input" placeholder="91XXXXXXXXXX" value={form.whatsapp} onChange={e => setForm({ ...form, whatsapp: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="label">Address</label>
              <textarea className="input" placeholder="Restaurant address" rows={2} value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} style={{ resize: 'none' }} />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="label">Logo URL</label>
              <input className="input" placeholder="https://your-logo-url.com/logo.png" value={form.logo} onChange={e => setForm({ ...form, logo: e.target.value })} />
              <p style={styles.hint}>Paste a direct image URL for your logo</p>
            </div>
          </div>

          <div className="card" style={{ marginBottom: 16 }}>
            <h3 style={styles.sectionTitle}><Clock size={16} style={{ marginRight: 6 }} />Opening Hours</h3>
            <p style={styles.hoursHint}>Customers will see "Open" or "Closed" based on these timings</p>
            <div style={styles.timeRow}>
              <div style={{ flex: 1 }}>
                <label className="label">Opening Time</label>
                <input className="input" type="time" value={form.opening_time} onChange={e => setForm({ ...form, opening_time: e.target.value })} />
              </div>
              <div style={{ flex: 1 }}>
                <label className="label">Closing Time</label>
                <input className="input" type="time" value={form.closing_time} onChange={e => setForm({ ...form, closing_time: e.target.value })} />
              </div>
            </div>
          </div>

          <button className="btn btn-primary btn-full" type="submit" disabled={saving}>
            {saving ? <span className="spinner" style={{ width: 18, height: 18 }} /> : <><Save size={18} /> Save Changes</>}
          </button>
        </form>
      )}
    </OwnerLayout>
  );
}

const styles = {
  logoCard: { textAlign: 'center', marginBottom: 12, padding: '24px' },
  logoPreview: { width: 90, height: 90, background: '#fff0eb', borderRadius: '50%', margin: '0 auto 8px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' },
  logoImg: { width: '100%', height: '100%', objectFit: 'cover' },
  logoHint: { fontSize: '12px', color: '#7F8C8D' },
  sectionTitle: { fontSize: '15px', fontWeight: '600', color: '#2C3E50', marginBottom: 14, display: 'flex', alignItems: 'center' },
  hint: { fontSize: '11px', color: '#7F8C8D', marginTop: 4 },
  timeRow: { display: 'flex', gap: 12 },
  hoursHint: { fontSize: '12px', color: '#7F8C8D', marginBottom: 12 },
};
